import React from 'react';

export const UserIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49">
      <g transform="translate(-685 -766)">
        <rect width="49" height="49" rx="6" transform="translate(685 766)" fill="var(--primary)"/>
        <path d="M69,57.5A6.5,6.5,0,1,1,62.5,51,6.5,6.5,0,0,1,69,57.5Z" transform="translate(647 723)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
        <path d="M67,62A14,14,0,0,0,53,76H81A14,14,0,0,0,67,62Z" transform="translate(643 732)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
      </g>
    </svg>

  );
};

export default UserIcon;